export const isFilterOffersActive = (selectedOfferCode: string, categories: string[]): boolean => {
  return !!selectedOfferCode || categories?.length > 0;
};
